<div class="bathroom-configuration-preview">
  @if (configuration?.composition) {
    <div class="bathroom-configuration-preview__capture" #previewCapture>
      <ng-casto-bathroom-render
        [composition]="configuration.composition"
        [selectedElement]="uiSelection?.selectedElement"
        [isLoading]="configuration.isPreviewLoading"
        (elementClick)="onElementClick($event)">
      </ng-casto-bathroom-render>
    </div>
  }
</div>
